import { render } from "./MtRecordDetail.vue?vue&type=template&id=2f6cc1a1&scoped=true"
import script from "./MtRecordDetail.vue?vue&type=script&lang=js"
export * from "./MtRecordDetail.vue?vue&type=script&lang=js"

import "./MtRecordDetail.vue?vue&type=style&index=0&id=2f6cc1a1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6cc1a1"]])

export default __exports__